import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IAddInputTrackedEventParams, IBasInfoState } from './definitions';
import { Features, isFeatureEnabled } from '../../../featureToggles/features';

const initialState: IBasInfoState = {
  records: {},
};
const MAX_EVENTS_PER_QUESTION = 300;

const basInfoSlice = createSlice({
  name: 'basInfo',
  initialState,
  reducers: {
    resetBasInfo(state) {
      state.records = {};
    },
    addInputTrackedEvent(state, action: PayloadAction<IAddInputTrackedEventParams>) {
      const { value, interactionType, questionId } = action.payload;
      const interaction = {
        value,
        interactionType,
        timestamp: new Date().toISOString(),
      };
      if (state.records[questionId]) {
        state.records[questionId].push(interaction);
      } else {
        state.records[questionId] = [interaction];
      }
      if (isFeatureEnabled(Features.redemPhase3Epic1)) {
        state.records[questionId] = state.records[questionId].slice(-MAX_EVENTS_PER_QUESTION);
      }
    },
  },
});

export const { addInputTrackedEvent, resetBasInfo } = basInfoSlice.actions;
export const basInfoReducer = basInfoSlice.reducer;
